// import React from 'react'

// export default function OfficeHub() {
//     return (
//         <section className="
//         relative overflow-hidden py-32 px-6
//         bg-[#020617]
//         before:content-[''] before:absolute before:inset-0
//     before: bg - [radial - gradient(ellipse_at_center, rgba(32, 73, 112, 0.55)_0 %, rgba(16, 23, 41, 0.95)_55 %, rgba(2, 6, 23, 1)_100 %)]
//     after: content - [''] after:absolute after: inset - 0
//     after: bg - [linear - gradient(135deg, rgba(2, 6, 23, 1)_0 %, rgba(15, 23, 42, 1)_35 %, rgba(2, 6, 23, 1)_100 %)]
//     after: opacity - 60
//     '">
//             Office Hub
//         </section >
//     )
// }
import React from "react";

import { Clock } from "lucide-react";

import "../assets/css/Office_hub.css";

import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import OneClickAttendance from "../component/OfficeHub/OneClickAttendance";
import SmartRequestManagement from "../component/OfficeHub/SmartRequestManagement";
import AttendanceGlance from "../component/OfficeHub/AttendanceGlance";
import TimesheetManagementShowcase from "../component/OfficeHub/TimesheetManagementShowcase";
import OfficeHubCTA from "../component/OfficeHub/OfficeHubCTA";
import { Helmet } from "react-helmet";

// Typography System
export const typography = {
  heading: "text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold",
  subHeading: "text-xl sm:text-2xl md:text-3xl font-semibold",
  title: "text-lg sm:text-xl md:text-2xl font-semibold",
  body: "text-sm sm:text-base md:text-lg text-gray-600",
  small: "text-xs sm:text-sm text-gray-500",
};
export default function OfficeHub() {
  return (
    <>
      <Helmet>
        <title>Office Hub, Simplified | Simplifyte</title>
      </Helmet>
      <HeaderMenu />
      <section className="officehub-wrap">
        {/* CONTENT */}
        <div className="officehub-container">
          <div className="officehub-center">
            {/* PILL */}
            {/* <div className="officehub-pill">
              <Clock className="w-5 h-5" />
              <span className="officehub-badge">Office Hub</span>
            </div> */}

            {/* TITLE */}
            <h2 className="officehub-title">Office Hub, Simplified</h2>

            {/* DESC */}
            <p className="officehub-desc">
              Manage requests, attendance, and timesheets in one centralized
              hub. Submit leave requests, track attendance logs, and manage
              timesheets seamlessly for both employees and managers.
            </p>
          </div>
        </div>
      </section>
      <OneClickAttendance />
      <SmartRequestManagement />
      <AttendanceGlance />
      <TimesheetManagementShowcase />
      <OfficeHubCTA />
      <CustomFooter />
    </>
  );
}
